<script>
    import {fade} from 'svelte/transition'
    import {getPercentage, getState} from '../utils'

    export let equipment;
    let sparkchart;

    let number_of_points = 100;

    let state = "";
    let percentage = 0;
    let stateDisplay = "";

    $: watchEquipmentState(equipment);

    function watchEquipmentState(_equipment) {
        percentage = getPercentage(_equipment) * 100;
        state = getState(_equipment, percentage);
    }

    $: watchState(state);

    function watchState(_state) {
        switch (_state) {
            case "danger":
                stateDisplay = "LOW-LOW";
                break;
            case "warning":
                stateDisplay = "LOW";
                break;
            default:
                stateDisplay = "NORMAL"
        }
    }

    $: watchSparkline(sparkchart, equipment);

    function watchSparkline(sparkchart, _equipment) {
        if (sparkchart === undefined || _equipment === undefined) return;
        let data = [0];
        if (_equipment.messages) {
            let messageLength = _equipment.messages.length;
            data = _equipment.messages
                    .slice(messageLength - number_of_points, messageLength)
                    .map(message => parseFloat(message.display));
        }
        jQuery(sparkchart).sparkline(data, {
            type: 'line',
            width: '100%',
            height: '50',
            lineColor: '#1e88e5',
            fillColor: '#FFF',
            spotColor: '#1e88e5',
            maxSpotColor: '#1e88e5',
            minSpotColor: '#1e88e5',
            highlightLineColor: 'rgba(0, 0, 0, 0.2)',
            highlightSpotColor: '#1e88e5'
        })
    }

    function resize() {
        watchSparkline(sparkchart, equipment);
    }
</script>

<svelte:window on:resize={resize}/>

<div class="col-lg-3 col-md-6" transition:fade="{{duration: 200}}">
    <div class="link" style="cursor: pointer;" onclick="location.href='#/equipment/{equipment.id}';">
        <div class="card">
            <div class="card-body">
                <div class="card-head padding-bottom-mini">
                    <div class="icon_container">
                        <img src="./dist/img/silot_icon.png" width="111">
                    </div>
                    <div class="card-infos" style="width: 200px">
                        <h4 class="card-title">{equipment.infos.name}</h4>
                        <h5 class="card-subtitle">Equipment #{equipment.id}</h5>
                        <p class="card-subtitle">Material type: <span>{equipment.infos.type}</span></p>
                    </div>
                </div>

                <h6>Level</h6>
                <span class="text-{state} level">{parseFloat(equipment.lastMessage.display).toFixed(1)} {equipment.infos.display_units? equipment.infos.display_units : equipment.units}</span>
                <div class="progress">
                    <div class="progress-bar bg-{state}" role="progressbar"
                         style="width: {percentage}%; height: 6px;"
                         aria-valuenow="{percentage}" aria-valuemin="0"
                         aria-valuemax="100"></div>
                </div>
                <span class="text-{state} level-detail">{stateDisplay} - {percentage.toFixed(0)}%</span>

                <div bind:this={sparkchart}></div>
            </div>
        </div>
    </div>
</div>